import store from '../store/store';
/**
 * Returns the mailbox junk email configuration object which is observable
 */
export default function getMailboxJunkEmailConfiguration() {
    return store.mailboxJunkEmailConfiguration;
}
//# sourceMappingURL=getMailboxJunkEmailConfiguration.js.map